import React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
/* @see: Will be uncommented when total numberOfReviews will be available
import VerifiedIcon from '@mui/icons-material/Verified';
import Rating from '@mui/material/Rating';
import StarBorderOutlined from '@mui/icons-material/StarBorderOutlined';
*/
import { Rating as RatingWithSalesCount, colorPalette } from '@next-common/mui';
export const RatingSummary = ({ numberOfSales, sellerRating }) => {
    return (React.createElement(Stack, { alignItems: "center" },
        React.createElement(Typography, { sx: {
                fontSize: '48px',
                fontWeight: 600,
                color: colorPalette.gray900,
            } }, sellerRating),
        React.createElement(Box, { component: "a", href: "https://help.fr.shopping.rakuten.net/hc/fr/articles/20082420341138-Charte-des-avis-Rakuten", sx: {
                cursor: 'pointer',
                textDecoration: 'none',
                '& :hover': {
                    textDecoration: 'underline',
                },
            }, target: "_blank", rel: "noopener noreferrer" },
            React.createElement(RatingWithSalesCount, { version: 1, iconLeft: true, size: 'sm', sellerRating: sellerRating || '', numberOfSale: numberOfSales || '' }))));
};
